import React from 'react';
import { IconLoader } from 'common/IconLoader';
import SvgAF, { IconAndText } from 'components/shared/SvgAF/SvgAF';
import Modal from 'components/shared/Modal/Modal';
import { isDeviceLocked } from 'common/utils/deviceTwinUtils';

import './PivotsLockModal.css';

const PivotsLockModal = ({
  setIsPivotLockModalOpen,
  handlePivotLock,
  targetDevice,
  serviceDevices,
  targetDeviceType
}) => {
  return (
    <div className="pivotLockModal">
      <Modal
        role="alertdialog"
        aria-labelledby="lock_unlock_pivot_modal_title"
        closeTargetRef={null}
        close={() => {
          setIsPivotLockModalOpen(false);
        }}
        animate={false}
        animateX={false}
        opaque={true}
        width={535}
        displayFlex={true}
        height={'fit-content'}
      >
        <div className="MaintenancePanelBar_PivotLockModal">
          <div id="lock_unlock_pivot_modal_title" className="MaintenancePanelBar_PivotLockModal_Header">
            <span>Lock/Unlock devices?</span>
          </div>
          <div className="MaintenancePanelBar_PivotLockModal_MidSection">
            <div className="PivotLockModal_StatusItem">
              <IconAndText
                customClass={'deviceLabel'}
                img={
                  targetDeviceType === 'echo' || targetDeviceType === 'subscriber'
                    ? IconLoader.icon_echo
                    : IconLoader.icon_donor
                }
                text={targetDevice.deviceId}
              />
              <IconAndText
                customClass={'statusLabel'}
                img={isDeviceLocked(targetDevice) ? IconLoader.locked_default : IconLoader.unlocked_default}
                text={['lock', 'locked'].includes(targetDevice.properties.reported.adminState) ? 'Locked' : 'Unlocked'}
              />
            </div>
          </div>
          {serviceDevices &&
            serviceDevices
              .filter((item) => item != null && item.type !== 'donor')
              .map((item, index) => {
                return (
                  <div className="MultiStatusPanelItemContainer" key={index}>
                    <div className="PivotLockModal_StatusItem">
                      <IconAndText customClass={'deviceLabel'} img={IconLoader.icon_service} text={item.deviceId} />
                      <IconAndText
                        customClass={'statusLabel'}
                        img={isDeviceLocked(item) ? IconLoader.locked_default : IconLoader.unlocked_default}
                        text={isDeviceLocked(item) ? 'Locked' : 'Unlocked'}
                      />
                    </div>
                  </div>
                );
              })}
          <div className="MaintenancePanelBar_PivotLockModal_Buttons">
            <button
              onClick={() => {
                setIsPivotLockModalOpen(false);
              }}
              className="MaintenancePanelBar_PivotLockModal_Buttons_Cancel"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                handlePivotLock('unlock');
                setIsPivotLockModalOpen(false);
              }}
              className="MaintenancePanelBar_PivotLockModal_Buttons_Unlock"
            >
              <SvgAF img={IconLoader.unlocked_default} />
              Unlock All Devices
            </button>
            <button
              onClick={() => {
                handlePivotLock('lock');
                setIsPivotLockModalOpen(false);
              }}
              className="MaintenancePanelBar_PivotLockModal_Buttons_Lock"
            >
              <SvgAF img={IconLoader.locked_reversed} />
              Lock All Devices
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default PivotsLockModal;
